var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.suggestions && _vm.suggestions.length
    ? _c(
        "div",
        { staticClass: "suggestions" },
        _vm._l(_vm.suggestions, function (e, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "suggestions__item",
              on: {
                click: function ($event) {
                  return _vm.setSuggestion(e)
                },
              },
            },
            [
              e.name
                ? _c("p", { staticClass: "single-long-string-nowrap" }, [
                    e.name.length > 30
                      ? _c("span", { attrs: { title: e.name } }, [
                          _vm._v(_vm._s(e.name)),
                        ])
                      : _c("span", [_vm._v(_vm._s(e.name))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              e.inn
                ? _c("p", [
                    _c("b", [_vm._v("ИНН: ")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(e.inn))]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              e.address
                ? _c("p", [
                    _vm._v("\n            " + _vm._s(e.address) + "\n        "),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }